module.exports = __webpack_public_path__ + "bc379936347a5c0724d807177b96e01c.pdf";